// import Swiper from 'swiper'; // this import not working with the scrollbar options
import Swiper from 'swiper/swiper-bundle.esm.js';

class SliderPictoTect {
  public component;
  public trigger;
  constructor() {
    this.component = document.querySelectorAll(
      '[data-component="slider-picto-text"]'
    );
    this.trigger = document.querySelectorAll(
      '[data-trigger="slider-picto-text"]'
    );
    if (this.component && this.trigger) {
      this._init();
    }
  }
  _init() {
    this.trigger.forEach((element) => {
      let mySwiper: any = null;
      const firstImage = element.querySelector('img');

      if (firstImage) {
        firstImage.onload = () => {
          if (mySwiper) {
            mySwiper.update();
          }
        };
      }

      mySwiper = new Swiper(element, {
        spaceBetween: 30,
        preloadImages: false,
        watchOverflow: true,
        slidesPerView: 'auto',
        freeMode: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
          hide: false
        }
      });
    });
  }
}

export const sliderPictoTect = new SliderPictoTect();
